<template>
  <!-- <div style=" width: 100%; height: 60px; margin-top: 20px;">
      <div style="width: 100%; height: 60px; display: flex; float: left;">
        <div class="footer" align="center">

          <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
            关于我们
          </el-button>

          <el-drawer
            title="关于我们"
            :visible.sync="drawer"
            :direction="direction"
            >
            <span>这里是由七组---何浩、万家晟、王翠所打造的Al算法竞赛平台，具体问题请点资助我们!</span>
          </el-drawer>

        </div>

        <div class="footer" align="center">

          <el-button @click="drawer1 = true" type="primary" style="margin-left: 16px;">
            投资我们
          </el-button>

          <el-drawer 
            title="资助我们"
            :visible.sync="drawer1"
            :direction="direction1"
            >
            <span><img src="../assets/image/hh.png" alt="" width="180px"></span>
            <span><img src="../assets/image/wjs.jpg" alt="" width="180px"></span>
          </el-drawer>

        </div>

        <div class="footer" align="center">

          <el-button @click="drawer2 = true" type="primary" style="margin-left: 16px;">
            意见反馈
          </el-button>

          <el-drawer
            title="意见反馈"
            :visible.sync="drawer2"
            :direction="direction2"
            >
            <span>你也配有意见，看上一个！</span>
          </el-drawer>

        </div>
        
        <div class="footer" align="center">

          <el-button @click="drawer3 = true" type="primary" style="margin-left: 16px;">
            商业合作
          </el-button>

          <el-drawer
            title="商业合作"
            :visible.sync="drawer3"
            :direction="direction3"
            >
            <span>暂时不合作捏，建议看第二个！</span>
          </el-drawer>

        </div>

        <div class="footer" align="center">

          <el-button @click="drawer4 = true" type="primary" style="margin-left: 16px;">
            免责声明
          </el-button>

          <el-drawer
            title="免责声明"
            :visible.sync="drawer4"
            :direction="direction4"
            >
            <pre>
访问者在接受本网站服务之前，请务必仔细阅读本条款并同意本声明。访问者访问本网站的行为以及通过各类方式利用本网站的行为，都将被视作是对本声明全部内容的无异议的认可；如有异议，请立即跟本网站协商，并取得本网站的书面同意意见。
<br>
第一条 访问者在从事与本网站相关的所有行为（包括但不限于访问浏览、利用、转载、宣传介绍）时，必须以善意且谨慎的态度行事；访问者不得故意或者过失的损害或者弱化本网站的各类合法权利与利益，不得利用本网站以任何方式直接或者间接的从事违反中国法律、国际公约以及社会公德的行为，且访问者应当恪守下述承诺：
<br>
1、传输和利用信息符合中国法律、国际公约的规定、符合公序良俗；
<br>
2、不将本网站以及与之相关的网络服务用作非法用途以及非正当用途；
<br>
3、不干扰和扰乱本网站以及与之相关的网络服务；
<br>
4、遵守与本网站以及与之相关的网络服务的协议、规定、程序和惯例等。
<br>

第二条 本网站郑重提醒访问者：请在转载、上载或者下载有关作品时务必尊重该作品的版权、著作权；如果您发现有您未署名的作品，请立即和我们联系，我们会在第一时间加上您的署名或作相关处理。
<br>
第三条 除我们另有明确说明或者中国法律有强制性规定外，本网站用户原创的作品，本网站及作者共同享有版权，其他网站及传统媒体如需使用，须取得本网站的书面授权，未经授权严禁转载或用于其它商业用途。
<br>
第四条 本网站内容仅代表作者本人的观点，不代表本网站的观点和看法，与本网站立场无关，相关责任作者自负。
<br>
第五条 本网站有权将在本网站内发表的作品用于其他用途，包括网站、电子杂志等，作品有附带版权声明者除外。
<br>
第六条 未经常本网站和作者共同同意，其他任何机构不得以任何形式侵犯其作品著作权，包括但不限于：擅自复制、链接、非法使用或转载，或以任何方式建立作品镜像。
<br>
第七条 本网站所刊载的各类形式（包括但不仅限于文字、图片、图表）的作品仅供参考使用，并不代表本网站同意其说法或描述，仅为提供更多信息，也不构成任何投资建议。对于访问者根据本网站提供的信息所做出的一切行为，除非另有明确的书面承诺文件，否则本网站不承担任何形式的责任。
<br>
第八条 当本网站以链接形式推荐其他网站内容时，本网站并不对这些网站或资源的可用性负责，且不保证从这些网站获取的任何内容、产品、服务或其他材料的真实性、合法性，对于任何因使用或信赖从此类网站或资源上获取的内容、产品、服务或其他材料而造成（或声称造成）的任何直接或间接损失，本网站均不承担任何责任。
<br>
第九条 访问者在本网站注册时提供的一些个人资料，本网站除您本人同意及第十条规定外不会将用户的任何资料以任何方式泄露给任何一方。
<br>
第十条 当政府部门、司法机关等依照法定程序要求本网站披露个人资料时，本网站将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本网站均得免责。
<br>
第十一条 由于用户将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露，本网站不负任何责任。
<br>
第十二条 本网站试题部分内容来自互联网，如无意中侵犯了哪个媒体 、公司 、企业或个人等的知识产权，请来电或致函告之，本网站将在规定时间内给予删除等相关处理，若有涉及版权费等问题，请及时提供相关证明等材料并与我们联系，通过友好协商公平公正原则处理纠纷。
<br>
第十三条 以上声明内容的最终解释权归AL算法竞赛平台（AL.com）所有。
          </pre>
          </el-drawer>

        </div>
      </div>
    </div> -->
    <div style="background-color: #E9E9EB">
      <div class="container" style="font-size:13px;">
        <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5 border-top" >
          <div class="col mb-3">
            <p class="text-muted">&copy; 2023</p>
          </div>

          <div class="col mb-3">

          </div>

          <div class="col mb-3">
            <h5 style="margin-bottom: 10px;">链接</h5>
            <ul class="nav flex-column">
              <li class="nav-item mb-2"><a href="#daohang" class="nav-link p-0 text-muted">Top</a></li>
              <li class="nav-item mb-2"><a href="/function" class="nav-link p-0 text-muted">首页</a></li>
              <li class="nav-item mb-2"><a href="/question" class="nav-link p-0 text-muted">题库</a></li>
              <li class="nav-item mb-2"><a href="/sweepstakes" class="nav-link p-0 text-muted">竞赛</a></li>
              <li class="nav-item mb-2"><a href="/homepage" class="nav-link p-0 text-muted">讨论区</a></li>
              <li class="nav-item mb-2"><a href="/MyInfomation" class="nav-link p-0 text-muted">个人</a></li>
            </ul>
          </div>

          <div class="col mb-3">
            <h5 style="margin-bottom: 10px;">社区</h5>
            <ul class="nav flex-column">
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">贡献指南</a></li>
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">常见问题</a></li>
            </ul>
          </div>

          <div class="col mb-3">
            <h5 style="margin-bottom: 10px;">了解我们</h5>
            <ul class="nav flex-column">
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">投资我们</a></li>
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">关于我们</a></li>
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">企业合作</a></li>
              <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">免责声明</a></li>
            </ul>
          </div>
        </footer>
      </div>
  </div>
</template>

<script>
export default {
    name:'Footer',
    data() {
        return {
            /* 页脚 */
            drawer: false,
            direction: 'btt',

            drawer1: false,
            direction1: 'btt',

            drawer2: false,
            direction2: 'btt',
            
            drawer3: false,
            direction3: 'btt',

            drawer4: false,
            direction4: 'btt',
        }
    },
    methods: {
        /* 页脚 */
    //   handleClose(done) {
    //     this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    //   },
    // },
    }
}
</script>

<style>
/* 页脚的样式 */
.footer{
  font-size:20px;
  width:20%;
  height: 60px;
}
  /* 页脚的样式 */
</style>